var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('policy-submenu'),(
			_vm.$store.state.tenantId === 'aeg_uat' || _vm.$store.state.tenantId === 'aeg'
		)?[_c('aeg-policy-transactions-list')]:(
			_vm.$store.state.tenantId === 'demo_uat' || _vm.$store.state.tenantId === 'demo'
		)?[_c('demo-policy-transactions-list')]:(_vm.$store.state.tenantId === 'demo2_uat')?[_c('demo2-policy-transactions-list')]:[_c('default-policy-transactions-list')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }